import moment from "moment-timezone";

interface TimezoneOption {
  label: string;
  value: string;
}

const generateTimezoneList = (): TimezoneOption[] => {
  const timezones = moment.tz.names();

  const timezoneOptions: TimezoneOption[] = timezones.map((timezone) => {
    const offset = moment.tz(timezone).utcOffset();
    const hours = Math.floor(Math.abs(offset) / 60);
    const minutes = Math.abs(offset) % 60;
    const sign = offset >= 0 ? "+" : "-";
    const formattedOffset = `UTC${sign}${String(hours).padStart(
      2,
      "0"
    )}:${String(minutes).padStart(2, "0")}`;

    return {
      label: `(${formattedOffset}) ${timezone.replace("_", " ")}`,
      value: timezone
    };
  });

  // UTC 오프셋 기준으로 정렬
  timezoneOptions.sort((a, b) => {
    const offsetA = moment.tz(a.value).utcOffset();
    const offsetB = moment.tz(b.value).utcOffset();
    return offsetA - offsetB;
  });

  return timezoneOptions;
};

const getUTC = (timeZone: string) => {
  const utcItem = generateTimezoneList().filter((item) => {
    return item?.value === timeZone;
  });
  if (utcItem.length > 0) {
    const label = utcItem[0].label.split(" ");
    return label[0].replace(/[()]/g, "") as string;
  }
  return "";
};

export { generateTimezoneList, getUTC };
